import React from 'react'

export const SafetyFields = ({ user, handleChange }) => {
  return (
    <>
      <h3 className="text-18 text-purple-dark mb-12">Safety Practices</h3>
      <div className="bg-white border-1 border-gray-200 shadow-100 rounded-10 px-20 sm:px-32 pt-32 mb-64">
        <fieldset className="border-b-default border-gray-200 mb-32 pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            How often do you eat at restaurants outside?
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="eatOutside-choice-1"
              name="eatOutside"
              value="frequently"
              onChange={handleChange}
              defaultChecked={user.profile.eatOutside === 'frequently'}
            />
            <label htmlFor="eatOutside-choice-1">Frequently</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="eatOutside-choice-2"
              name="eatOutside"
              value="sometimes"
              onChange={handleChange}
              defaultChecked={user.profile.eatOutside === 'sometimes'}
            />
            <label htmlFor="eatOutside-choice-2">Sometimes</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="eatOutside-choice-3"
              name="eatOutside"
              value="never"
              onChange={handleChange}
              defaultChecked={user.profile.eatOutside === 'never'}
            />
            <label htmlFor="eatOutside-choice-3">Never</label>
          </div>
        </fieldset>
        <fieldset className="border-b-default border-gray-200 mb-32 pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            Do you interact with people not in your household outdoors?
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="outdoorsHang-choice-1"
              name="outdoorsHang"
              value="frequently"
              onChange={handleChange}
              defaultChecked={user.profile.outdoorsHang === 'frequently'}
            />
            <label htmlFor="outdoorsHang-choice-1">Frequently</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="outdoorsHang-choice-2"
              name="outdoorsHang"
              value="sometimes"
              onChange={handleChange}
              defaultChecked={user.profile.outdoorsHang === 'sometimes'}
            />
            <label htmlFor="outdoorsHang-choice-2">Sometimes</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="outdoorsHang-choice-3"
              name="outdoorsHang"
              value="never"
              onChange={handleChange}
              defaultChecked={user.profile.outdoorsHang === 'never'}
            />
            <label htmlFor="outdoorsHang-choice-3">Never</label>
          </div>
        </fieldset>
        <fieldset className="border-b-default border-gray-200 mb-32 pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            Do you interact with people not in your household indoors?
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="indoorsHang-choice-1"
              name="indoorsHang"
              value="frequently"
              onChange={handleChange}
              defaultChecked={user.profile.indoorsHang === 'frequently'}
            />
            <label htmlFor="indoorsHang-choice-1">Frequently</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="indoorsHang-choice-2"
              name="indoorsHang"
              value="sometimes"
              onChange={handleChange}
              defaultChecked={user.profile.indoorsHang === 'sometimes'}
            />
            <label htmlFor="indoorsHang-choice-2">Sometimes</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="indoorsHang-choice-3"
              name="indoorsHang"
              value="never"
              onChange={handleChange}
              defaultChecked={user.profile.indoorsHang === 'never'}
            />
            <label htmlFor="indoorsHang-choice-3">Never</label>
          </div>
        </fieldset>
        <fieldset className="border-b-default border-gray-200 mb-32 pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            How often do you wear a mask?
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="mask-choice-1"
              name="mask"
              value="always"
              onChange={handleChange}
              defaultChecked={user.profile.mask === 'always'}
            />
            <label htmlFor="mask-choice-1">Every time I leave my house</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="mask-choice-2"
              name="mask"
              value="mostly"
              onChange={handleChange}
              defaultChecked={user.profile.mask === 'mostly'}
            />
            <label htmlFor="mask-choice-2">Most of the time</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="mask-choice-3"
              name="mask"
              value="need"
              onChange={handleChange}
              defaultChecked={user.profile.mask === 'need'}
            />
            <label htmlFor="mask-choice-3">When I have to</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="mask-choice-4"
              name="mask"
              value="never"
              onChange={handleChange}
              defaultChecked={user.profile.mask === 'never'}
            />
            <label htmlFor="mask-choice-4">I don’t wear masks</label>
          </div>
        </fieldset>
        <fieldset className="border-b-default border-gray-200 mb-32 pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            Have you traveled out of state in the last 10 days?
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="travel-choice-1"
              name="travel"
              value="yes"
              onChange={handleChange}
              defaultChecked={user.profile.travel === 'yes'}
            />
            <label htmlFor="travel-choice-1">Yes</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="travel-choice-2"
              name="travel"
              value="no"
              onChange={handleChange}
              defaultChecked={user.profile.travel === 'no'}
            />
            <label htmlFor="travel-choice-2">No</label>
          </div>
        </fieldset>
        <fieldset className="border-b-default border-gray-200 mb-32 pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            Do you go grocery shopping in person on a regular basis?
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="groceries-choice-1"
              name="groceries"
              value="yes"
              onChange={handleChange}
              defaultChecked={user.profile.groceries === 'yes'}
            />
            <label htmlFor="groceries-choice-1">Yes</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="groceries-choice-2"
              name="groceries"
              value="no"
              onChange={handleChange}
              defaultChecked={user.profile.groceries === 'no'}
            />
            <label htmlFor="groceries-choice-2">No</label>
          </div>
        </fieldset>
        <fieldset className="pb-20 px-0">
          <legend className="text-16 text-purple-dark font-bold mb-12">
            Have you used public transportation in the last 10 days? This can
            include Uber or Lyft, bus or subway, or a commercial flight.
          </legend>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="transport-choice-1"
              name="transport"
              value="yes"
              onChange={handleChange}
              defaultChecked={user.profile.transport === 'yes'}
            />
            <label htmlFor="transport-choice-1">Yes</label>
          </div>
          <div className="mb-12">
            <input
              className="mr-16"
              type="radio"
              id="transport-choice-2"
              name="transport"
              value="no"
              onChange={handleChange}
              defaultChecked={user.profile.transport === 'no'}
            />
            <label htmlFor="transport-choice-2">No</label>
          </div>
        </fieldset>
      </div>
    </>
  )
}
